import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoginModal from "../../../components/LoginModal";
import { SubUser } from "../../../services/models/sub_user";
import { LoginCredentials } from "../../../services/models/credentials";
import * as SubUserApi from "../../../services/network/sub_user-api";
import styleUtils from "../../../assets/styles/utils.module.css";
import styleAuth from "../../../assets/styles/AuthPage.module.css";

interface SubUserAuthPageProps {
    onLoginSuccessful: (sub_user: SubUser) => void,
}

const SubUserAuthPage = ({onLoginSuccessful}: SubUserAuthPageProps) => {
    let navigate = useNavigate();
    const routeChange = () =>{
        let path = `cabinet`;
        navigate(path);
    }
    async function onSubmit(credentials: LoginCredentials) {
        try {
            const loginResponse = await SubUserApi.loginSubUser(credentials);
            localStorage.setItem("user", JSON.stringify(loginResponse))
            
            // Получаем полные данные пользователя с ролями
            const subUser = await SubUserApi.getLoggedSubUser();
            onLoginSuccessful(subUser);
            routeChange();
        } catch (error) {
            toast.error("Неверный логин или пароль");
            console.error(error);
        }
    }

    return (
        <>
            <h1 className={`${styleUtils.flexCenter} ${styleAuth.authAdminTitle}`}>Авторизация пользователя</h1>
            <LoginModal onSubmit={onSubmit}/>
        </>
        
);
}

export default SubUserAuthPage;